import React from 'react';
import SocialLogin from 'react-social-login';

//Return social login button
const Button = ({ children, triggerLogin, ...props }) => {
  return (
    <button onClick= {triggerLogin} {...props}>
      {children}
    </button>
  )
};

export default SocialLogin(Button);


// WEBPACK FOOTER //
// ./web/components/salesUser/login/SalesSocialLogin.js